import React, { useEffect } from 'react'
import './Product.css'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { DashboardContext } from '../../Hooks/DashboardContext'
import { getUniqueDoc } from '../../firebase/utils'
import Stars from '../Stars/Stars'


const Product = ({prodDetails}) => {

  const {setidProduct,setcurrentProduct}=useContext(DashboardContext)

  const navigateTo=useNavigate() 

  const DelHandler=()=>{

    if(prodDetails.id===null) return
    setidProduct(prodDetails.id)
    document.querySelector('.ConfirmDialog').showModal()
    
  }

  const SelectProduct= async ()=>{
  
    const produit= await getUniqueDoc('Produits',prodDetails.id)
    setidProduct(prodDetails.id)
    setcurrentProduct(produit)
    navigateTo('../ProductsMenu/AddProduct')


  }
  


  return (

    <div className='ProductContainer'>

      <div className='delbtn' onClick={DelHandler}>X</div>

      <div className='Product' onClick={SelectProduct} idproduct={prodDetails.id}>
          <div className='ImgContainer'>
              <img src={prodDetails.UrlsImages[0]===null?"":prodDetails.UrlsImages[0]} alt=""  />
          </div>
          <div className='DetailsContainer'>
              <span className='Nom'>{prodDetails.Nom}</span>
              <span className='Prix'>{prodDetails.PrixInApp} XAF</span>
              {/*<span className='Categorie'>{prodDetails.Categorie}</span>*/}
              <span className='TauxPromo'>{prodDetails.TauxPromo}</span>
              {/*<span className='Rates'>{prodDetails.Rates} Etoiles</span>*/}
              <Stars Rates={prodDetails.Rates} onClick={e=>{return}}/>
          </div>
      </div>

    </div>
  )
}

export default Product